<!-- Copyright by the Spark Development Network; Licensed under the Rock Community License -->
<template>
    <div class="form-group static-control">
        <label :class="['control-label', labelCssClass]" :for="id">
            <slot name="label">{{ label }}</slot>
        </label>
        <div class="control-wrapper">
            <div class="form-control-static" :id="id">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { newGuid } from "@Obsidian/Utility/guid";

    defineProps({
        label: {
            type: String,
            default: ""
        },

        labelCssClass: {
            type: String,
            default: ""
        }
    });

    const id = "literal-" + newGuid();
</script>